export const API_URL = import.meta.env.VITE_API_URL
export const TURNSTILE_KEY = import.meta.env.VITE_TURNSTILE_KEY
